// A street address the way people write it (Ryan/Jenny, Oct 1 2026). The map picker hands
// back the geocoder's whole breadcrumb — "The Backcountry, 11400, Donner Pass Road, Meadow
// Lake Park, Gateway, Truckee, Nevada County, California, 96161, United States" — and that
// was printing on the quote. This boils it down to "11400 Donner Pass Road, Truckee, CA 96161".
// Anything that doesn't look like that breadcrumb (a typed address, a plain town) comes back
// as it was. The server has the same function (tidyAddress in api.js) — keep them in step.
const STATES = { alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA', colorado: 'CO', connecticut: 'CT', delaware: 'DE', florida: 'FL', georgia: 'GA', hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN', iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME', maryland: 'MD', massachusetts: 'MA', michigan: 'MI', minnesota: 'MN', mississippi: 'MS', missouri: 'MO', montana: 'MT', nebraska: 'NE', nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK', oregon: 'OR', pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC', 'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT', vermont: 'VT', virginia: 'VA', washington: 'WA', 'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY', 'district of columbia': 'DC' };

export function tidyAddress(s) {
  const raw = String(s || '').trim();
  if (!raw) return raw;
  const parts = raw.split(',').map(p => p.trim()).filter(Boolean);
  if (parts.length < 4) return raw;
  // The breadcrumb ends …, <state>, <zip>, United States — that is how we know it's one.
  let end = parts.length;
  if (/^(united states( of america)?|usa|us)$/i.test(parts[end - 1])) end--;
  let zip = null, stateIdx = -1;
  if (/^\d{5}(-\d{4})?$/.test(parts[end - 1] || '')) { zip = parts[end - 1]; end--; }
  if (end >= 1 && STATES[(parts[end - 1] || '').toLowerCase()]) stateIdx = end - 1;
  if (stateIdx < 0 && end >= 1 && /^[A-Z]{2}$/.test(parts[end - 1] || '')) stateIdx = end - 1;
  if (stateIdx < 0 || !zip) return raw;
  const state = STATES[parts[stateIdx].toLowerCase()] || parts[stateIdx];
  let cityIdx = stateIdx - 1;
  if (cityIdx >= 0 && /\bcounty$/i.test(parts[cityIdx])) cityIdx--;   // "Nevada County" is not a town
  const city = cityIdx >= 0 ? parts[cityIdx] : '';
  // The street: a bare house number followed by the road; or a part that starts with one.
  const head = parts.slice(0, Math.max(cityIdx, 0));
  let street = '';
  for (let i = 0; i < head.length; i++) {
    if (/^\d+[A-Za-z]?$/.test(head[i]) && head[i + 1] && /[A-Za-z]/.test(head[i + 1])) { street = `${head[i]} ${head[i + 1]}`; break; }
    if (/^\d+[A-Za-z]?\s+\S/.test(head[i])) { street = head[i]; break; }
  }
  if (!street) {
    // No house number: the first named part before the neighbourhood-level filler is the best we have.
    street = head[0] || '';
  }
  const tail = [city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return [street, tail].filter(Boolean).join(', ');
}

export default tidyAddress;
